import Typography from '@material-ui/core/Typography'
import { ClassNameMap } from '@material-ui/styles'
import React from 'react'

interface EmptyListProps {
  isLoading: boolean
  classes: ClassNameMap<'dropdownItem' | 'dropdown'>
  onLoadingMessage?: string
  onEmptyMessage?: string
}

export const EmptyList = ({
  isLoading,
  classes,
  onLoadingMessage = 'Carregando...',
  onEmptyMessage = 'Nenhum item encontrado',
}: EmptyListProps) => {
  return (
    <Typography className={classes.dropdownItem}>
      {isLoading ? onLoadingMessage : onEmptyMessage}
    </Typography>
  )
}
